module.exports = __webpack_public_path__ + "img/TechArchAttack1_ua.8fba7422.webp";